import { render, staticRenderFns } from "./helpAndSupport.vue?vue&type=template&id=04e3bb22&scoped=true"
import script from "./helpAndSupport.vue?vue&type=script&lang=js"
export * from "./helpAndSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e3bb22",
  null
  
)

export default component.exports